import React from 'react';
import LinkBase from './LinkBase';

const BlockLink = (props) => <LinkBase {...props} kind="block" />;

export default BlockLink;
